import { useContext, useState } from 'react';
import { format } from 'date-fns';
import ActivityCalendar from 'react-activity-calendar';
import { faSquarePollVertical } from '@fortawesome/pro-regular-svg-icons';
import { useTheme } from 'styled-components';
import { SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { StyledTabPaper } from 'src/features/public-profile/public-profile.styles';
import { ToolTip } from 'src/common/components';
import { StyledContainers, StyledFontAwesomeIcon, StyledFooter, StyledHeader, StyledHeaderTitleWithIcon } from 'src/features/public-profile/components/yearly-activity-tab/yearly-activity-tab.style';
import { TotalEvents } from 'src/features/public-profile/components/yearly-activity-tab/components/total-events/total-events';
import { ThemeColorMode } from 'src/common/enums';
import { YearlyActivityProps } from 'src/features/public-profile/components/yearly-activity-tab/yearly-activity.types';
import { useGetYearlyActivityQuery } from 'src/features/public-profile/components/yearly-activity-tab/yearly-activity.slice';
import { YearlyActivity } from 'src/common/interfaces/public-profile';
import { Key } from './components/key/key';
import { Year } from './components/year/year';
const formatDate = (date: string): string => format(new Date(date), 'dd/MM/yyyy');
export const YearlyActivityTab = ({
  userId,
  dateSignUp
}: YearlyActivityProps) => {
  const theme = useTheme();
  const {
    theme: themeName
  } = useContext(SwitchThemeContext);
  const isDarkMode = themeName === ThemeColorMode.DARK;
  const currentYear = new Date().getFullYear();
  const signupYear = new Date(dateSignUp).getFullYear();
  const [year, setYear] = useState<number>(currentYear);
  const {
    data,
    isLoading
  } = useGetYearlyActivityQuery({
    user: userId,
    year: year.toString()
  }, {
    skip: !userId || !year
  });
  const onRightClick = () => {
    if (year < currentYear) {
      setYear(prevYear => prevYear + 1);
    }
  };
  const onLeftClick = () => {
    if (year > signupYear) {
      setYear(prevYear => prevYear - 1);
    }
  };
  return <StyledTabPaper data-sentry-element="StyledTabPaper" data-sentry-component="YearlyActivityTab" data-sentry-source-file="yearly-activity-tab.tsx">
      <StyledHeader data-sentry-element="StyledHeader" data-sentry-source-file="yearly-activity-tab.tsx">
        <StyledHeaderTitleWithIcon data-sentry-element="StyledHeaderTitleWithIcon" data-sentry-source-file="yearly-activity-tab.tsx">
          <StyledFontAwesomeIcon icon={faSquarePollVertical} data-sentry-element="StyledFontAwesomeIcon" data-sentry-source-file="yearly-activity-tab.tsx" /> Yearly activity
        </StyledHeaderTitleWithIcon>
        <Year onRightClick={onRightClick} onLeftClick={onLeftClick} year={year} data-sentry-element="Year" data-sentry-source-file="yearly-activity-tab.tsx" />
      </StyledHeader>
      <StyledContainers data-sentry-element="StyledContainers" data-sentry-source-file="yearly-activity-tab.tsx">
        <Key data-sentry-element="Key" data-sentry-source-file="yearly-activity-tab.tsx" />
        <TotalEvents total={data?.data?.totalCount} data-sentry-element="TotalEvents" data-sentry-source-file="yearly-activity-tab.tsx" />
      </StyledContainers>
      <ActivityCalendar loading={isLoading} data={data?.data?.yearlyActivity ?? []} blockSize={17} blockRadius={3} blockMargin={5} fontSize={16} maxLevel={3} weekStart={1} showWeekdayLabels colorScheme={isDarkMode ? 'dark' : 'light'} hideTotalCount hideColorLegend style={{
      width: '100%',
      height: '100%',
      alignItems: 'center',
      color: theme.colors.text.main,
      fontWeight: 700
    }} renderBlock={(block, activity: YearlyActivity) => <ToolTip toolTipText={<div>
                {formatDate(activity.date)}
                <br />
                <b>{activity.count}</b> events
              </div>} delayDuration={100}>
            {block}
          </ToolTip>} theme={{
      light: [theme.colors.activityCalendar.levelZero, theme.colors.activityCalendar.levelOne, theme.colors.activityCalendar.levelTwo, theme.colors.activityCalendar.levelThree],
      dark: [theme.colors.activityCalendar.levelZero, theme.colors.activityCalendar.levelOne, theme.colors.activityCalendar.levelTwo, theme.colors.activityCalendar.levelThree]
    }} data-sentry-element="ActivityCalendar" data-sentry-source-file="yearly-activity-tab.tsx" />
      <StyledFooter data-sentry-element="StyledFooter" data-sentry-source-file="yearly-activity-tab.tsx">
        Activity events are measured by the number of machines started, questions answered or file downloads.
      </StyledFooter>
    </StyledTabPaper>;
};